{
  "version": 1,
  "asset_id": "6508888f-6683-45ae-aaad-b0f1ec134083",
  "project_id": "ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe",
  "url": "/__l5e/assets-v1/6508888f-6683-45ae-aaad-b0f1ec134083/eddy-vidal-96.webp",
  "r2_key": "a/v1/ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe/6508888f-6683-45ae-aaad-b0f1ec134083/eddy-vidal-96.webp",
  "original_filename": "eddy-vidal-96.webp",
  "size": 1242,
  "content_type": "image/webp",
  "created_at": "2026-09-18T14:36:48Z"
}
